import { render, staticRenderFns } from "./page-loader.vue?vue&type=template&id=13301a98&"
import script from "./page-loader.vue?vue&type=script&lang=js&"
export * from "./page-loader.vue?vue&type=script&lang=js&"
import style0 from "./page-loader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports